import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../App';
import { useEffect, useState } from 'react';
import './Sidebar.css';

/* Inline lucide-style icons — match the dashboard mockup exactly */
const Icon = {
  Dashboard: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="9"/><rect x="14" y="3" width="7" height="5"/>
      <rect x="14" y="12" width="7" height="9"/><rect x="3" y="16" width="7" height="5"/>
    </svg>
  ),
  OrderTaking: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="3" width="16" height="18" rx="2"/>
      <path d="M9 8h6M9 12h6M9 16h4"/>
    </svg>
  ),
  History: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0z"/>
      <path d="M12 7v5l3 2"/>
    </svg>
  ),
  Setup: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  ),
  Costs: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      {/* Wallet — cash expenses tracker */}
      <path d="M20 7H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a3 3 0 0 1 3-3h13a1 1 0 0 1 1 1v2z"/>
      <circle cx="17" cy="14" r="1.2" fill="currentColor"/>
    </svg>
  ),
  Inventory: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      {/* Stacked boxes — stock/inventory */}
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
      <path d="M3.27 6.96 12 12.01l8.73-5.05M12 22.08V12"/>
    </svg>
  ),
  AI: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      {/* Sparkles — large 4-point star + two small accents, the de facto AI glyph */}
      <path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3z"/>
      <path d="M19 14l.7 1.8 1.8.7-1.8.7L19 19l-.7-1.8-1.8-.7 1.8-.7L19 14z"/>
      <path d="M5 16l.5 1.3 1.3.5-1.3.5L5 19.6l-.5-1.3-1.3-.5 1.3-.5L5 16z"/>
    </svg>
  ),
  Udharo: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      {/* Hand-coins — credit money owed, coming back to you */}
      <path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"/>
      <path d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"/>
      <path d="m2 16 6 6"/>
      <circle cx="16" cy="9" r="2.9"/>
    </svg>
  ),
  Menu: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 6h18M3 12h18M3 18h18"/>
    </svg>
  ),
  Logout: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
      <path d="M16 17l5-5-5-5M21 12H9"/>
    </svg>
  ),
};

const NAV_OPERATE = [
  { path: '/dashboard', label: 'Dashboard',     short: 'Home',    Icon: Icon.Dashboard,   roles: ['owner','manager','staff'] },
  { path: '/orders',    label: 'Order Taking',  short: 'Take',    Icon: Icon.OrderTaking, roles: ['owner','manager','staff'] },
];
const NAV_INSIGHTS = [
  { path: '/history', label: 'Reports',                  short: 'Reports', Icon: Icon.History, roles: ['owner','manager'] },
  { path: '/udharo',  label: 'Udharo · Credit Book',     short: 'Udharo',  Icon: Icon.Udharo,  roles: ['owner','manager'] },
  { path: '/ai',      label: 'VI · Vyapar Intelligence', short: 'VI',      Icon: Icon.AI,      roles: ['owner','manager'] },
];
const NAV_MANAGE = [
  { path: '/setup',     label: 'Setup',         short: 'Setup',   Icon: Icon.Setup,       roles: ['owner','manager','staff'] },
];

/* Sub-tab icons — visually consistent with the main nav icons (1.7 stroke). */
const SubIcon = {
  Menu: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 6h16M4 12h16M4 18h12"/>
    </svg>
  ),
  Tables: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <path d="M3 12h18M12 3v18"/>
    </svg>
  ),
  Team: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="8" r="3"/>
      <path d="M3 20c0-3 2.5-6 6-6s6 3 6 6"/>
      <circle cx="17" cy="9" r="2.5"/>
      <path d="M14 19c0-2 1.5-4 3-4s3 2 3 4"/>
    </svg>
  ),
  Payment: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6" width="20" height="12" rx="2"/>
      <path d="M2 10h20"/>
    </svg>
  ),
  Notifications: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M14 21a2 2 0 0 1-4 0"/>
    </svg>
  ),
  Other: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9"/>
      <circle cx="12" cy="12" r="2"/>
    </svg>
  ),
  Offers: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 12V7a2 2 0 0 0-2-2h-5l-9 9 7 7 9-9z"/>
      <circle cx="9" cy="9" r="1.4" fill="currentColor"/>
    </svg>
  ),
};

/* Setup sub-tabs — shown indented under Setup. Sub-tabs navigate to
   /setup?tab=<key>; Setup.jsx reads the query param. */
const SETUP_SUBTABS = [
  { key: 'menu',    label: 'Menu',          Icon: SubIcon.Menu,          roles: ['owner','manager','staff'] },
  { key: 'tables',  label: 'Tables',        Icon: SubIcon.Tables,        roles: ['owner','manager','staff'] },
  { key: 'users',   label: 'Team',          Icon: SubIcon.Team,          roles: ['owner']                   },
  { key: 'payment', label: 'Payment',       Icon: SubIcon.Payment,       roles: ['owner']                   },
  { key: 'offers',  label: 'Offers',        Icon: SubIcon.Offers,        roles: ['owner']                   },
  { key: 'notify',  label: 'Notifications', Icon: SubIcon.Notifications, roles: ['owner']                   },
  { key: 'other',   label: 'Other',         Icon: SubIcon.Other,         roles: ['owner','manager','staff'] },
];

export default function Sidebar() {
  const { user, logout, token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const handleLogout = () => { logout(); navigate('/login'); };

  // Mobile: the sidebar is an off-canvas drawer toggled by the bottom-bar ☰.
  // It closes automatically whenever the route (or Setup sub-tab) changes.
  const [drawerOpen, setDrawerOpen] = useState(false);
  useEffect(() => { setDrawerOpen(false); }, [location.pathname, location.search]);

  // Fetch the cost-tracking flag so the Costs tab only appears when on.
  // We seed the initial state from localStorage so the tab doesn't flicker
  // off → on every time the Sidebar re-mounts during navigation. The
  // network refresh runs in the background and updates the cache.
  const COST_CACHE_KEY = 'vyapar_cost_tracking_enabled';
  const [costEnabled, setCostEnabled] = useState(() => {
    try { return localStorage.getItem(COST_CACHE_KEY) === '1'; }
    catch (_) { return false; }
  });
  useEffect(() => {
    if (!token) return;
    let cancelled = false;

    // Apply whatever the dashboard batch already cached for us. /dashboard
    // now returns { costsSettings } and the shared API cache seeds the
    // '/costs/settings' key when that lands — so when this Sidebar mounts
    // on a fresh login, the costs flag is often already known and we can
    // skip the dedicated /api/costs/settings request entirely.
    const apply = (j) => {
      if (cancelled || !j) return;
      const next = !!j.cost_tracking_enabled;
      setCostEnabled(next);
      try { localStorage.setItem(COST_CACHE_KEY, next ? '1' : '0'); } catch (_) {}
    };

    let needsFetch = true;
    try {
      const raw = localStorage.getItem('vyapar_cache:/costs/settings');
      if (raw) {
        const entry = JSON.parse(raw);
        if (entry?.data) {
          apply(entry.data);
          // Skip the network if the cached settings are still fresh.
          if (Date.now() - entry.ts < 10 * 60 * 1000) needsFetch = false;
        }
      }
    } catch (_) { /* corrupt or empty — fall through to fetch */ }

    const load = async () => {
      try {
        const r = await fetch(`${process.env.REACT_APP_API_BASE || ''}/api/costs/settings`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!r.ok) return;
        apply(await r.json());
      } catch (_) {}
    };
    if (needsFetch) load();
    const onChange = () => load();
    window.addEventListener('costs:settings-changed', onChange);
    return () => { cancelled = true; window.removeEventListener('costs:settings-changed', onChange); };
  }, [token]);

  const visible = (items) => items.filter(item => item.roles.includes(user?.role));
  // Sidebar groups (desktop):
  //   Operate              — Dashboard, Order Taking, Cost Tracking (if on)
  //   Reports and Insights — Reports, VI · Vyapar Intelligence
  //   Manage               — Setup (+ its sub-tabs)
  // On mobile the section labels are hidden by CSS, so the icons just flow.
  const operate  = visible(NAV_OPERATE.concat(
    costEnabled
      ? [
          { path: '/costs',     label: 'Cost Tracking', short: 'Costs', Icon: Icon.Costs,     roles: ['owner','manager'] },
          { path: '/inventory', label: 'Inventory',     short: 'Stock', Icon: Icon.Inventory, roles: ['owner','manager'] },
        ]
      : []
  ));
  const insights = visible(NAV_INSIGHTS);
  const manage   = visible(NAV_MANAGE);
  const setupSubtabs = SETUP_SUBTABS.filter(t => t.roles.includes(user?.role));

  // Mobile bottom bar — the few most-used destinations. Everything else
  // (Cost Tracking, Inventory, VI, Setup + sub-tabs, Sign out) lives in the
  // ☰ drawer. Reports is owner/manager-only; staff get Dashboard + Orders.
  const bottomItems = [
    { path: '/dashboard', label: 'Home',   Icon: Icon.Dashboard },
    { path: '/orders',    label: 'Orders', Icon: Icon.OrderTaking },
    ...(user?.role !== 'staff' ? [{ path: '/history', label: 'Reports', Icon: Icon.History }] : []),
  ];

  /* Active sub-tab is read from ?tab=… on /setup. Default 'menu' for safety. */
  const onSetup     = location.pathname.startsWith('/setup');
  const activeSubtab = new URLSearchParams(location.search).get('tab') || 'menu';

  const renderLink = ({ path, label, short, Icon: I }) => (
    <NavLink
      key={path}
      to={path}
      className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
    >
      <span className="sidebar-icon"><I /></span>
      <span className="sb-label-full">{label}</span>
      <span className="sb-label-short">{short || label}</span>
    </NavLink>
  );

  return (
    <>
    {/* Mobile drawer backdrop */}
    <div
      className={`mobile-drawer-backdrop${drawerOpen ? ' show' : ''}`}
      onClick={() => setDrawerOpen(false)}
      aria-hidden="true"
    />
    <aside className={`sidebar${drawerOpen ? ' drawer-open' : ''}`}>
      {/* Brand wordmark — matches login chrome (saffron lambda + Vyapar Pro) */}
      <div className="sidebar-brand-block">
        <svg className="sidebar-wordmark-mark" viewBox="0 0 24 24"><path d="M3 3 L11 21 L13 21 L21 3 L17 3 L12 14 L7 3 Z" fill="#D4A537"/></svg>
        <div>
          <div className="sidebar-brand">Vyapar <span className="pro">Pro</span></div>
          <div className="sidebar-tagline">व्यापार <span className="pro">Pro</span></div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {operate.length > 0 && (
          <>
            <div className="sidebar-nav-label">Operate</div>
            {operate.map(renderLink)}
          </>
        )}

        {insights.length > 0 && (
          <>
            <div className="sidebar-nav-label" style={{ marginTop: 18 }}>Reports and Insights</div>
            {insights.map(renderLink)}
          </>
        )}

        {manage.length > 0 && (
          <>
            <div className="sidebar-nav-label" style={{ marginTop: 18 }}>Manage</div>
            {manage.map(item => (
              <React.Fragment key={item.path}>
                {renderLink(item)}
                {/* Sub-nav: always visible under Setup. Active state only
                    lights up when the user is actually on the /setup route. */}
                {item.path === '/setup' && setupSubtabs.length > 0 && (
                  <div className="sidebar-subnav">
                    {setupSubtabs.map(st => {
                      const I = st.Icon;
                      return (
                        <button
                          key={st.key}
                          type="button"
                          className={`sidebar-sublink${onSetup && activeSubtab === st.key ? ' active' : ''}`}
                          onClick={() => navigate(`/setup?tab=${st.key}`)}
                        >
                          <span className="sidebar-subicon"><I /></span>
                          {st.label}
                        </button>
                      );
                    })}
                  </div>
                )}
              </React.Fragment>
            ))}
          </>
        )}

        {/* Mobile-only logout tab */}
        <button className="sidebar-link sidebar-logout-tab" onClick={handleLogout}>
          <span className="sidebar-icon"><Icon.Logout /></span>
          <span className="sb-label-full">Sign out</span>
          <span className="sb-label-short">Sign out</span>
        </button>
      </nav>

      {/* Sign out — desktop + drawer bottom row */}
      <button className="sidebar-signout" onClick={handleLogout} title="Sign out">
        <span className="sidebar-icon"><Icon.Logout /></span>
        <span>Sign out</span>
      </button>
    </aside>

    {/* Mobile bottom bar — key destinations + ☰ that opens the full drawer */}
    <nav className="mobile-bottombar" aria-label="Primary navigation">
      {bottomItems.map(({ path, label, Icon: I }) => (
        <NavLink key={path} to={path} className={({ isActive }) => `mbar-item${isActive ? ' active' : ''}`}>
          <I /><span>{label}</span>
        </NavLink>
      ))}
      <button type="button" className={`mbar-item${drawerOpen ? ' active' : ''}`} onClick={() => setDrawerOpen(o => !o)} aria-label="More menu">
        <Icon.Menu /><span>Menu</span>
      </button>
    </nav>
    </>
  );
}
